import '../styles/Button.scss';
import { Link } from 'react-router-dom';

function PlainButton({ text, slug }) {
	return (
		<Link to={`/portfolio/${slug ? slug : ``}`} className="Plain-button-wrap">
			<span className="Plain-button-text">{text}</span>
		</Link>
	);
}

export default PlainButton;
